import { Link } from 'react-router-dom'
import { MdSegment, MdKeyboardArrowRight } from 'react-icons/md'
import { Header, Leftside, UserActions, Separator } from './styles'
import MenuPopover from '../MenuPopover'
// import { useDispatch } from 'react-redux';
// import * as actions from '../../store/modules/auth/actions'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import CartPopover from '../CartPopover'
import { useMediaQuery } from '@mui/material'

interface HeaderPlatformProps {
    isMenuOpen: boolean
    setIsMenuOpen: (valor: boolean) => void
}

export default function HeaderPlataform({
    isMenuOpen,
    setIsMenuOpen,
}: HeaderPlatformProps) {
    const { mainMenu, subMenu, currentLink } = useSelector(
        (state: StoreState) => state.menu
    )
    const menuBurger = useMediaQuery('(max-width:678px)')
    return (
        <Header>
            <Leftside>
                {menuBurger && (
                    <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        <MdSegment size={25} />
                    </button>
                )}
                <nav>
                    <Link to={currentLink}>{mainMenu}</Link>
                    {subMenu && (
                        <>
                            <MdKeyboardArrowRight color="#333" size={14} />
                            <span>{subMenu}</span>
                        </>
                    )}
                </nav>
            </Leftside>
            <UserActions>
                <div className="cart">
                    <CartPopover />
                </div>

                <Separator />
                {/* <div className='messages'>
                    <IconButton aria-label="show new mails" color="inherit">
                        <Badge badgeContent={4} color='error'>
                            <MdOutlineMailOutline color='#333' size={20}/>
                        </Badge>
                    </IconButton>
                </div>
                <div className='notifications'>
                    <IconButton
                        size="small"
                        aria-label="show 17 new notifications"
                        color="inherit"
                    >
                        <Badge badgeContent={17} color="error">
                            <FiBell color='#333' size={20}/>
                        </Badge>
                    </IconButton>
                </div> */}
                <MenuPopover />
            </UserActions>
        </Header>
    )
}
